<form [formGroup]="commentForm">
  <ng-container *transloco="let loco; prefix: 'pages.comments'">
    <clr-textarea-container>
      <label>{{ loco('add_comment') }}</label>
      <textarea clrTextarea  formControlName="reason" placeholder="Kommentar" required></textarea>
      <clr-control-helper>{{ loco('description_helper') }}</clr-control-helper>
      <clr-control-error *clrIfError="'required'">{{ loco('description_error') }}</clr-control-error>
    </clr-textarea-container>
    <clr-select-container>
      <label>{{ loco('contact_person') }}</label>
      <select clrSelect formControlName="person_id" required>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <clr-control-helper>{{ loco('contact_helper') }}</clr-control-helper>
      <clr-control-error>{{ loco('contact_error') }}</clr-control-error>
    </clr-select-container>
    <br>
    <clr-date-container class="moveUp">
      <label>Erinnerung am (optional)</label>
      <input type="date" clrDate placeholder="{{ null | date: 'dd.MM.yyyy' }}" formControlName="remember" />
    </clr-date-container>
    <br>
    <button class="btn btn-primary btn-sm" (click)="addComment()" [disabled]="commentForm.invalid">Speichern</button>
  </ng-container>
</form>

<!--<pre class="datepicker-output" *ngIf="devMode">
    {{ commentForm.value | json }}
</pre>-->
